import React, { useEffect, useState } from "react";
import { EventTips } from "./EventTips";
import {EventTipsImage} from "./EventTipsImage";

export const eventTips_Page = () => {
  const [selTab, setSelTab] = useState(1);

  const tab = (name, id, isActive) => {
    return (
      <li className="nav-item" role="presentation">
        <a
          className={`nav-link ${isActive && " active"}`}
          href={"#tab" + id}
          data-bs-toggle="tab"
          aria-selected={isActive ? "true" : "false"}
          role="tab"
          onClick={() => setSelTab(id)}
        >
          {name}
        </a>
      </li>
    );
  };

  useEffect(() => {
    const tabLinks = document.querySelectorAll(".nav-link");
    tabLinks.forEach((link) => {
      link.addEventListener("shown.bs.tab", (e) => {
        const newTabId = parseInt(
          e.target.getAttribute("href").replace("#tab", "")
        );
        setSelTab(newTabId);
      });
    });

    return () => {
      tabLinks.forEach((link) => {
        link.removeEventListener("shown.bs.tab", () => {});
      });
    };
  }, []);

  return (
    <>
      <div className="page-header">
        <div className="row">
          <div className="col-sm-12">
            <h3 className="page-title">Event Tips</h3>
            <ul className="breadcrumb">
              <li className="breadcrumb-item">
                <li>Configuration</li>
              </li>
              <li className="breadcrumb-item active">Event Tips</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="card bg-white">
        <div className="card-body">
          <ul
            className="nav nav-tabs nav-tabs-bottom nav-justified"
            role="tablist"
          >
            {tab("Event Tips", 1, selTab == 1)}
            {tab("Image Configuration", 2, selTab == 2)}
          </ul>
          <div className="tab-content">
            <div
              className={`tab-pane ${selTab == 1 ? "active show" : ""}`}
              id="tab1"
              role="tabpanel"
            >
              {selTab == 1 && <EventTips selTab={selTab} />}
            </div>
            <div
              className={`tab-pane ${selTab == 2 ? "active show" : ""}`}
              id="tab2"
              role="tabpanel"
            >
              {selTab == 2 && <EventTipsImage selTab={selTab} />}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
